import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AIMarkersDialogComponent } from './ai-markers-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TrackByPropPipeModule } from '@go-modules/pipes/track-by-prop/track-by-prop-pipe.module';
import { CommonModule } from '@angular/common';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { GoAriaPressedDirective } from '@go-modules/directives/aria-pressed';
import { MarkerModule } from '@go-modules/components/marker/marker.module';
import { TeaseWallModule } from '@go-modules/directives/tease-wall/tease-wall.module';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		TrackByPropPipeModule,
		GoSelectModule,
		GoAriaPressedDirective,
		MarkerModule,
		A11yModule,
		TeaseWallModule
	],
	declarations: [
		AIMarkersDialogComponent
	],
	exports: [
		AIMarkersDialogComponent
	]
})
export class AIMarkersDialogModule {}
